import {Box, Grid, Skeleton} from '@mui/material';

const SignContractSkeleton = () => {
    return (
        <>
            <Skeleton width={250} height={40} />
            {/* cards section */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    gap: '1rem',
                    marginTop: '1.5rem',
                    height: '200px',
                    overflowY: 'auto',
                    marginBottom: '20px',
                    width: '100%',
                }}
            >
                {[...Array(2)].map((index) => (
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            padding: '1rem',
                            borderRadius: '5px',
                            border: '1px solid #D7DBEC',
                        }}
                    >
                        <Skeleton
                            width={'100%'}
                            height={40}
                            key={index}
                            sx={{transform: 'unset'}}
                        />
                    </Box>
                ))}
            </Box>
            {/* otp section */}
            <Skeleton width={'100%'} height={40} />
            <Grid container width={'100%'}>
                {[...Array(6)].map((_, index) => (
                    <Grid item xs={2} sx={{paddingX: '1.1rem !important'}}>
                        <Skeleton width={'100%'} height={70} key={index} />
                    </Grid>
                ))}
            </Grid>
            {/* sign btn */}
            <div className="button-container">
                <Skeleton
                    width={'100%'}
                    height={40}
                    sx={{transform: 'unset'}}
                />
            </div>
        </>
    );
};

export default SignContractSkeleton;
